import React from 'react';
import PropTypes from 'prop-types';
import { HotelStars } from '@lt/components';

import { useTranslation } from '@lt/localization';
import ReviewsList from '../../containers/Reviews/ReviewsList';
import Breadcrumbs from '../Breadcrumbs';

import styles from './reviews.module.css';

const ReviewsMobile = ({ breadcrumbs, stars, hotelName }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className={styles.headerContainer}>
        <div className={styles.starsContainer}>
          <HotelStars value={stars} />
          <Breadcrumbs
            className={styles.breadcrumbs}
            items={breadcrumbs}
            fadeColor="#f3f3f3"
          />
        </div>
        <h2 className={styles.header}>
          {`${t('hotel.reviews.title')} `}
          <strong className={styles.hotelName}>{hotelName}</strong>
        </h2>
      </div>
      <div className="lt-hotel-reviews__items">
        <ReviewsList />
      </div>
    </div>
  );
};

ReviewsMobile.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  hotelName: PropTypes.string.isRequired,
  stars: PropTypes.number.isRequired,
};

export default ReviewsMobile;
